import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { RadioButton } from 'spicecomponents';

const KidAdultSelector = (props) => {
  const options = [
    { value: 'kid', text: 'Kids data' },
    { value: 'adult', text: 'Adults data' },
  ];

  return (
    <Div>
      <RadioButton name="KidAdult" value={props.kidAdult} options={options} onChange={(value) => { props.storeKidAdult(value); }} />
    </Div>
  );
};

const Div = styled.div`
  margin-top: 10px;
`;

KidAdultSelector.propTypes = {
  storeKidAdult: PropTypes.func,
  kidAdult: PropTypes.string,
};

export default KidAdultSelector;



// WEBPACK FOOTER //
// ./app/components/FormControls/KidAdultSelector/index.js